let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dx9iv")).then(() => parcelRequire('4NIhb'));